const {
  REACT_APP_STAGE,
  REACT_APP_VAULT_SERVICE_API_URL_DEV,
  REACT_APP_VAULT_SERVICE_API_URL_UAT,
  REACT_APP_VAULT_SERVICE_API_URL_STAG,
  REACT_APP_VAULT_SERVICE_API_URL_PROD,
  REACT_APP_IDENTITY_POOL_ID_DEV,
  REACT_APP_IDENTITY_POOL_ID_UAT,
  REACT_APP_IDENTITY_POOL_ID_STAG,
  REACT_APP_IDENTITY_POOL_ID_PROD,
  REACT_APP_REGION_DEV,
  REACT_APP_REGION_UAT,
  REACT_APP_REGION_STAG,
  REACT_APP_REGION_PROD,
  REACT_APP_USER_POOL_ID_DEV,
  REACT_APP_USER_POOL_ID_UAT,
  REACT_APP_USER_POOL_ID_STAG,
  REACT_APP_USER_POOL_ID_PROD,
  REACT_APP_USER_POOL_CLIENT_ID_DEV,
  REACT_APP_USER_POOL_CLIENT_ID_UAT,
  REACT_APP_USER_POOL_CLIENT_ID_STAG,
  REACT_APP_USER_POOL_CLIENT_ID_PROD,
} = process.env;

let identityPoolId;
let region;
let userPoolId;
let userPoolWebClientId;
let serviceUrl;

if (REACT_APP_STAGE === 'local') {
  serviceUrl = 'http://localhost:8080';
}

if (REACT_APP_STAGE === 'dev') {
  identityPoolId = REACT_APP_IDENTITY_POOL_ID_DEV;
  region = REACT_APP_REGION_DEV;
  userPoolId = REACT_APP_USER_POOL_ID_DEV;
  userPoolWebClientId = REACT_APP_USER_POOL_CLIENT_ID_DEV;
  serviceUrl = getUrl(REACT_APP_VAULT_SERVICE_API_URL_DEV, region);
}

if (REACT_APP_STAGE === 'uat') {
  identityPoolId = REACT_APP_IDENTITY_POOL_ID_UAT;
  region = REACT_APP_REGION_UAT;
  userPoolId = REACT_APP_USER_POOL_ID_UAT;
  userPoolWebClientId = REACT_APP_USER_POOL_CLIENT_ID_UAT;
  serviceUrl = getUrl(REACT_APP_VAULT_SERVICE_API_URL_UAT, region);
}

if (REACT_APP_STAGE === 'stag') {
  identityPoolId = REACT_APP_IDENTITY_POOL_ID_STAG;
  region = REACT_APP_REGION_STAG;
  userPoolId = REACT_APP_USER_POOL_ID_STAG;
  userPoolWebClientId = REACT_APP_USER_POOL_CLIENT_ID_STAG;
  serviceUrl = getUrl(REACT_APP_VAULT_SERVICE_API_URL_STAG, region);
}

if (REACT_APP_STAGE === 'prod') {
  identityPoolId = REACT_APP_IDENTITY_POOL_ID_PROD;
  region = REACT_APP_REGION_PROD;
  userPoolId = REACT_APP_USER_POOL_ID_PROD;
  userPoolWebClientId = REACT_APP_USER_POOL_CLIENT_ID_PROD;
  serviceUrl = getUrl(REACT_APP_VAULT_SERVICE_API_URL_PROD, region);
}

function getUrl(gateway, urlRegion) {
  return `https://${gateway}.execute-api.${urlRegion}.amazonaws.com/${REACT_APP_STAGE}`;
}

export const amplifyConfig = {
  Auth: {
    identityPoolId,
    region,
    userPoolId,
    userPoolWebClientId,
    mandatorySignIn: false,
  },
  API: {
    endpoints: [
      {
        name: 'vaulting-portal-api',
        endpoint: serviceUrl,
      },
    ],
  },
};

export const vaultingServiceUrl = serviceUrl;
